<template>
    <div class="header">
        <div class="nav-box">
            <div class="logo-box">
                <app-link class="icon" to="/"></app-link>
            </div>

            <div class="menu">

                <ul class="list-box">
                    <li>
                        <app-link to="/">首页</app-link>
                    </li>
                    <li>
                        <app-link to="/article">文章</app-link>
                    </li>
                    <li>
                        <app-link to="/exper">经验</app-link>
                    </li>
                </ul>

                <div class="manage-box" v-if="hasToken">
                    <el-dropdown>
                        <el-button class="btn-box" type="primary" icon="el-icon-menu">管理中心</el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="goMaster">
                                <i class="icon el-icon-user"></i>用户中心
                            </el-dropdown-item>
                            <el-dropdown-item divided @click.native="logout">
                                <i class="icon el-icon-switch-button"></i>退出登录
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                <div class="btns-box" v-else>
                    <div class="item-box">
                        <app-link class="bth login" to="/login">登录</app-link>
                    </div>
                    <div class="item-box">
                        <app-link class="bth reg" to="/reg">注册</app-link>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import AppLink from "@/components/common/link";
import auth from "@/core/auth";
import { Dropdown, DropdownMenu, Button } from "element-ui";
import appConfig from "@/config/app"; 

Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(Button);

const page = {
    data() {
        return {
            hasToken: "",
        };
    },
    props: {
        navData: {
            type: Object,
            default: () => {},
        },
    },
    components: {
        AppLink,
    },
    methods: {
        goMaster() {
            const href = appConfig.domain.master;
            document.location.href = href;
        },
        async logout() {
            const href = appConfig.domain.app;
            await this.$store.dispatch("user/logout").then(() => {
                document.location.href = href;
            });
        },
        handleLink(){
            this.$refs.productDropdown.hide();
        }
    },
    created: function () {
        const hasToken = auth.getToken();
        this.hasToken = hasToken;
    },
};
export default page;
</script>

<style lang="scss" scoped>
.header {
    height: 70px;
    line-height: 70px;
    background-color: #fff;
}

.header .nav-box {
    margin: 0 auto;
    width: 1200px;
    height: 100%;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.header .logo-box {
    display: flex;
}

.header .logo-box .icon {
    display: block;
    width: 160px;
    height: 70px;
    background: url("~@/assets/images/public/logo.png") center no-repeat;
    background-size: contain;
}

.header .logo .icon img {
    width: 100%;
    height: 100%;
}

.header .logo-box .slogan {
    font-size: 16px;
    margin-left: 20px;
    color: #aaa;
}

.header .menu {
    display: flex;
    align-items: center;
    height: 70px;
    flex: 1;
    justify-content: space-between;
}

.header .menu .list-box {
    // flex: 1;
    display: flex;
    justify-content: center;
}

.header .menu .list-box .current {
    color: var(--primary-color);
}

.header .menu ul li {
    position: relative;
    display: block;
    padding: 0 1rem;
}

.header .menu ul li a {
    font-size: 1rem;
    color: #222;
    text-decoration: none;
    transition: color 0.3s;
    cursor: pointer;
    font-weight: bold;
}

.header .menu ul li a:hover {
    color: var(--primary-color);
}

.header .manage-box {
    display: inline-block;
    position: relative;
    vertical-align: top;
    margin-left: 30px;
}

.header .manage-box .btn-box {
    height: 70px;
    border-radius: 0;
}

.header .btns-box {
    display: flex;
    align-items: center;
    padding-right: 10px;
}

.header .bth {
    display: inline-block;
    border: none;
    outline: none;
    background-color: #fff;  
    border: 1px solid #0049ff;
    color: #0049ff;
    border-radius: 4px;
    cursor: pointer;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    height: 38px;
    padding: 0 32px;
    font-size: 14px;
    font-weight: 500;
    line-height: 38px; 
}

.header .btns-box .login {
    margin-right: 20px; 
}

.header .btns-box .login:hover {
    opacity: 0.8;
    transition: background-color 0.3s, border-color 0.3s;
}

.header .btns-box .reg {
    background-color:#0049ff;
    color: #fff;
}

.header .btns-box .reg:hover {
    opacity: 0.8;
}

@media screen and (max-width: 767px) {
    .header .nav-box {
        width: 100%;
    }
    .header .logo-box .icon {
        width: 60px;
        height: 40px;
    }
    .header .logo-box .slogan {
        font-size: 0.8em;
    }

    .header .menu {
        height: 60px;
    }

    .header .btns-box {
        margin-right: 0px;
    }
}

</style>


// WEBPACK FOOTER //
// src/layout/app/components/navbar/index.vue